<template>
    <v-layout justify-center>
        <v-flex xs12 mt-4>

            <v-form
                    v-model="valid"
                    row
                    justify-center>

                <v-layout wrap>

                    <v-flex xs12 text-left pa-1 v-if="payment">
                        <v-select
                                :hint="hint"
                                :readonly="readonly"
                                label="Estado del Pago"
                                :items="statusOptions"
                                v-model="status_detail" />
                    </v-flex>

                    <v-flex pa-1 xs12 >
                        <v-text-field
                                autofocus
                                :readonly="readonly"
                                :error-messages="amountError"
                                label="Monto"
                                prefix="$"
                                v-model="amount" />
                    </v-flex>
<!--

                    <v-flex xs12 mt-2>
                        <label-picker box :readonly="readonly" :value="defaultLabels" type="payment" @change="onLabelsChange"/>
                    </v-flex>
-->

                    <v-flex xs12 text-left>
                        <v-textarea
                                :readonly="readonly"
                                :error-messages="!comments ? 'Obligatorio: lo verá el cliente al momento de pagar' : ''"
                                fillled
                                v-model="comments"
                                label="Motivo del cobro"></v-textarea>
                    </v-flex>


                </v-layout>

            </v-form>
        </v-flex>

    </v-layout>
</template>

<script>

    import { mapState, mapActions } from 'vuex'
    import {labels} from '@/utils/Payment'
    import LabelPicker from "../common/LabelPicker";

    export default{
        props: {
            payment:{
                type: Object
            }
        },
        components: {LabelPicker},
        mounted(){
             this.setDefault()
        },
        data(){
            return {
                status: 'pending',
                status_detail: 'pending',
                amount: 0,
                comments: '',
                labels: [],
            }
        },
        watch:{
            valid(val){
                this.$emit('change:valid', val)
            },
            value(val){
                this.setDefault()
            },
            amount(val){
                this.amount = this.formatAmount(val)
            },
            paymentData(val){
                this.$emit('change', val)
            },
            payment(){
                this.setDefault()
            }
        },
        computed:{
            ...mapState(['loader', 'currentBranchOffice']),
            hint(){
              const vm = this
              return vm.status_detail !== 'pending' ? 'Se cambias el estado, ya no podrás volver a editar este pago' : ''
            },
            defaultLabels(){
              const vm = this
              return vm.payment && vm.payment.labels ? JSON.parse(JSON.stringify(vm.payment.labels)) : []
            },
            amountError(){
                var vm = this
                if(!vm.amount || Number(vm.amount) === 0 || isNaN(Number(vm.amount))){
                    return 'monto inválido'
                }

                return ''
            },
            voucherNumberError(){
                var vm = this
                if(vm.type === 'medical_voucher' && !vm.voucherNumber) {
                    return 'Requerido cuando la atención es por bono'
                }

                return ''
            },
            statusOptions(){

                var statuses = []
                for(var attr in labels){
                    statuses.push({
                        value: attr,
                        text: labels[attr]
                    })
                }

                return statuses
            },
            typeOptions(){
                return [
                    {
                        value: 'private',
                        text:'De pago'
                    },
                    {
                        value: 'free',
                        text:'Sin costo'
                    }
                ]
            },
            paymentOptions(){
                return [
                    {
                        value: 'na',
                        text:'Ninguno'
                    },
                    {
                        value: 'cash',
                        text:'Efectivo'
                    },
                    {
                        value: 'credit',
                        text:'Crédito'
                    },
                    {
                        value: 'debit',
                        text:'Débito'
                    }
                ]
            },
            paymentData(){

                var vm = this
                let paymentData = {
                    status_detail: vm.status_detail,
                    amount: vm.amount && vm.amount.replace(/\./g, ''),
                    comments: vm.comments,
                    labels: vm.labels
                }

                return paymentData

            },
            valid(){

                var vm = this
                if(!vm.amount || isNaN(Number(vm.amount.toString().replace(/\./g, '')))) return false
                if(!vm.comments) return false
                if(vm.readonly) return false

                return true

            },
            readonly(){
                const vm = this
                return vm.status === 'done'
            }
        },
        methods:{
            onLabelsChange(labels){
                const vm = this
                vm.labels = labels
            },
            formatAmount(num) {
                if(!num) return 0
                return num.toString()
                        .replace(/^0/g, '')
                        .replace(/\./g, '')
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
            },
            setDefault(){
                var vm = this
                if(!vm.payment) return
                vm.status = vm.payment.status || 'pending'
                vm.status_detail = vm.payment.status_detail || 'pending'
                vm.comments = vm.payment.comments || ''
                vm.amount = vm.payment.amount || 0
                vm.labels = vm.payment.labels || []

            },
            reset(){

                var vm = this
                vm.status = 'pending'
                vm.statusstatus_detail = 'pending'
                vm.type = 'private'
                vm.amount = 0
                vm.paymentMethod = 'na'
                vm.voucherNumber = ''

            }

        }

    }

</script>
